export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getFooterContent() {
            return new Promise((resolve, reject) => {
                window.axios.get("/setting/footer")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateFooter(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/footer", data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

